var _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHowItWorksLineDivider(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 87,
    viewBox: "0 0 1 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    x2: 0.5,
    y2: 87,
    stroke: "#CDCEE5",
    strokeDasharray: "5 8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowItWorksLineDivider);
export default __webpack_public_path__ + "static/media/how-it-works-line-divider.21a77fac4de2dd609a5d8caea8c81da5.svg";
export { ForwardRef as ReactComponent };